import { Header } from "components/Header"
import { View, Pressable, ActivityIndicator } from "react-native"
import { Alert } from "components/ui/confirm"
import { trpc } from "utils/trpc"
import { Link, router } from "expo-router"
import { ar } from "i18n/ar"
import { List } from "@src/components/list"
import { Text } from "components/core"
import { useNumCols } from "@src/hooks"
import MIcon from "@react-native-vector-icons/material-design-icons"
import { sharedStyles } from "@src/utils"

export default function Employees() {
  const employees = trpc.employees.list.useQuery()
  const deactiveate = trpc.employees.deactivate.useMutation()
  const utils = trpc.useUtils()
  const numCols = Math.max(2, useNumCols(250, { maxWidth: 1400 }))

  const header = (
    <Header
      title={ar.employees}
      right={
        <Pressable onPress={() => router.push("/dashboard/employee/new")} className="px-2 h-full justify-center">
          <MIcon name="plus" size={24} color="black" />
        </Pressable>
      }
    />
  )

  return (
    <View className="flex-1 bg-gray-100">
      {header}
      <List
        contentContainerStyle={sharedStyles.contentContainer}
        data={employees.data ?? []}
        numColumns={numCols}
        key={`employees-grid-${numCols}`}
        keyExtractor={(item) => item.id.toString()}
        onRefresh={employees.refetch}
        ListEmptyComponent={
          employees.isLoading ? <ActivityIndicator className="py-8" /> : <Text className="text-gray-500 text-center py-8">No employees found</Text>
        }
        renderItem={({ item: employee }) => (
          <Link href={`/dashboard/employee/${employee.id}`} asChild>
            <Pressable className="bg-white mx-1 mb-2 p-5 rounded shadow-sm hover:shadow-xl transition-all border border-gray-100 active:opacity-70 min-h-[120] items-center justify-center">
              <MIcon name="account-circle" size={48} color="#FFD700" />
              <Text className="text-base font-bold text-gray-900 text-center mt-3" numberOfLines={2}>
                {employee.name || employee.username}
              </Text>
              <Text className="text-sm text-gray-600 font-medium mt-1 text-center">{ar[employee.role]}</Text>
              <View className="absolute top-2 right-2 flex-row gap-3">
                <Link href={`/dashboard/employee/${employee.id}/edit`} asChild>
                  <Pressable>
                    <MIcon name="pencil" size={25} color="#3B82F6" />
                  </Pressable>
                </Link>
                <Pressable
                  onPress={() => {
                    Alert.alert(ar.delete, ar.deleteEmployeeConfirmation, [
                      { text: ar.cancel, style: "cancel" },
                      {
                        text: ar.delete,
                        style: "destructive",
                        onPress: async () => {
                          await deactiveate.mutateAsync({ id: employee.id })
                          utils.employees.list.invalidate()
                        },
                      },
                    ])
                  }}
                >
                  <MIcon name="delete" size={25} color="#EF4444" />
                </Pressable>
              </View>
            </Pressable>
          </Link>
        )}
      />
    </View>
  )
}
